import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { Filter } from '@adc/ui-adc'
import { track } from '@adc/analytics'
import styles from './styles.scss'

const cx = classNames.bind(styles)

const MapViewFilterButton = ({ data, actions }) => {
  const moreFiltersDefinition = useMemo(() => {
    return data?.filtersData?.filterDefinitions?.find(
      d => d.name === 'moreFilters'
    )
  }, [data?.filtersData?.filterDefinitions])

  const moreFiltersData = data?.filtersData?.filterViewModels?.moreFilters

  if (!moreFiltersDefinition || !moreFiltersData) {
    return null
  }

  return (
    <div
      className={cx('map-filter-wrapper')}
      onClick={() =>
        track('srp-filters-button-click', { source: 'map-view-floating' })
      }
    >
      <Filter
        data={moreFiltersData}
        definition={moreFiltersDefinition}
        elmId='mobile_map_moreFilters_filter'
        isLoading={data?.isLoading}
        resultsAmount={data?.listings?.total_count}
        onChange={(key, value) =>
          actions?.onFancyFilterChange(moreFiltersDefinition, key, value)
        }
        onReset={() => actions?.onFancyFilterReset(moreFiltersDefinition)}
        useEnhancedDrawer
        variant='floating'
      />
    </div>
  )
}

MapViewFilterButton.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
}

export default MapViewFilterButton
